module.exports = __webpack_public_path__ + "static/media/unilehu.93dd410e.jpeg";